<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div id="defaultId1 " style="padding-bottom: 20px">
    <div id="g2ede8" class="operations-content">
      <h2 id="gf7b16" class="operations-head detail_title_20 margin-bottom20">
        <div>
          <span
            class="operations-headspan margin-right40"
            v-if="activeIEports == '1'"
          >
            Target Enterprise Trade Trend
          </span>
          <span
            class="operations-headspan margin-right40"
            v-if="activeIEports == '2'"
          >
            Target Enterprise Trade Trend
          </span>
          <el-select
            style="width: 20rem"
            v-model="datePicker"
            multiple
            :multiple-limit="2"
            placeholder="Please Select"
            @change="SelectPicker"
          >
            <el-option
              v-for="item in Yearoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="flex_between_box">
          <div class="perations-content-left margin-left20">
            <span
              :class="
                activeIEports == '1'
                  ? 'perations-button perations-button-active'
                  : 'perations-button'
              "
              @click="ceckIEports('1')"
            >
              Imports</span
            >
            <span
              @click="ceckIEports('2')"
              :class="
                activeIEports == '2'
                  ? 'perations-button perations-button-active'
                  : 'perations-button'
              "
              >Exports</span
            >
          </div>
        </div>
      </h2>

      <div></div>
      <div class="operations-box">
        <div ref="SupplyChainEchart" style="width: 100%; height: 642px"></div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import { showTradeTrendsOfTargetCountries } from "@/api/companyApi.js";
import ReLogin from "../../../../components/ReLogin.vue";
export default {
  name: "",
  // props: {},
  components: {
    ReLogin,
  },
  data() {
    return {
      data: {
        links: [],
        nodes: [],
      },

      datePicker: [2014, 2023],

      activeIEports: "1",
      importTrendListEcharts: [],

      Yearoptions: [
        {
          value: 2024,
          label: 2024,
        },
        {
          value: 2023,
          label: 2023,
        },
        {
          value: 2022,
          label: 2022,
        },
        {
          value: 2021,
          label: 2021,
        },
        {
          value: 2020,
          label: 2020,
        },
        {
          value: 2019,
          label: 2019,
        },
        {
          value: 2018,
          label: 2018,
        },
        {
          value: 2017,
          label: 2017,
        },
        {
          value: 2016,
          label: 2016,
        },
        {
          value: 2015,
          label: 2015,
        },
        {
          value: 2014,
          label: 2014,
        },
        {
          value: 2013,
          label: 2013,
        },
      ],
      reLoginVis: false,
    };
  },
  mounted() {
    this.getData();
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    resizeFn() {
      this.suppleEchart();
    },
    SelectPicker() {
      this.datePicker = this.datePicker.sort(function (a, b) {
        return a - b;
      });
      this.getData();
    },
    ceckIEports(row) {
      this.activeIEports = row;
      this.getData();
    },
    getData() {
      showTradeTrendsOfTargetCountries({
        startYear: this.datePicker[0],
        importOrExportType: this.activeIEports,
        country: this.$route.query.id3a,
        endYear: this.datePicker[1],
      }).then((res) => {
        if (res.code == 200) {
          if (this.activeIEports == "1") {
            this.importTrendListEcharts = res.data.importData;
          } else {
            this.importTrendListEcharts = res.data.exportData;
          }

          this.suppleEchart();
        }
      });
    },
    suppleEchart() {
      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "0%", // 设置左侧边距
          right: "0%",
          top: "5%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          right: "10px",
          top: "0px",
          //  width: '200px'
          // 其他图例配置项
          // ...
        },
        xAxis: {
          type: "category",
          data: that.importTrendListEcharts.map((item) => item.date),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
          axisLabel: {
            color: "#1A2332", // 设置字体颜色
            fontSize: 16, // 可以在这里设置字体大小
            fontWeight: "normal", // 字体粗细
            fontFamily: "Arial, Arial", // 字体类型,
          },
        },
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8497AB",
              },
            },
            // 背景虚线
            splitLine: {
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#8398BB",
              },
            },
            axisLabel: {
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: "{value} ",
            },
          },
          // {
          //   type: 'value',
          //   position: 'right',
          //   alignTicks: true,
          //   min: -100,
          //   max: 100,
          //   interval: 20,
          //   axisLabel: {
          //     formatter: '{value} %'
          //   }

          // }
        ],
        series: [
          {
            name: "Transactions",
            type: "bar",
            barWidth: "60",
            itemStyle: { color: "#009EA7", barBorderRadius: [5, 5, 0, 0] },
            emphasis: {
              itemStyle: {
                color: "#009EA7",
              },
            },
            data: that.importTrendListEcharts.map((item) => item.amount),
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },
  },
  computed: {},
};
</script>
<style scoped>
.operations-content {
  padding: 30px 40px;
  height: 100%;
}

.operations-head {
  font-size: 2.142857143rem;
  font-family: "Arial Bold";

  color: #1a2332;
  text-align: left;
  font-style: normal;
  display: flex;
  justify-content: space-between;
}

.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.table-content-color {
  color: #009ea7;
}

/deep/ .el-range-editor.el-input__inner {
  padding: 0px !important;
}
/deep/ .el-tag.el-tag--info {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #1a2332;
  font-size: 1.285714rem;
}
/deep/ .el-icon-close {
  display: none !important;
}

/*cssStart*/

/*cssEnd*/
</style>
